module.exports = __webpack_public_path__ + "img/array1.4b669c9f.png";